// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__2zXU_","description":"PatientConsentPreview_description__2gq0R"};